import { useCallback } from 'react';
import { openModal, closeModal, openToast } from 'utils/localDispatcher';
import StartDeliveryModal from 'components/chatMain/chatOrder/StartDeliveryModal';
import { DeliveryCompany } from '__generated__/commerce';
import { startDeliveryV2 } from 'apis/CommerceGraphql/chatOrder';

export const useStartDeliveryModal = () => {
  const openStartDeliveryModal = useCallback((storeOrderId: string) => {
    const handleClose = () => {
      closeModal();
    };

    const handleSubmit = async (formData: {
      storeOrderId: string;
      company: DeliveryCompany | null;
      invoice: string;
      onSuccess: () => void;
      onFailure: (errorType: string, message?: string | null) => void;
    }) => {
      try {
        const result = await startDeliveryV2(
          formData.storeOrderId,
          formData.company,
          formData.invoice
        );
        
        if (result.orderSheet) {
          return formData.onSuccess();
        }

        if (result.error) {
          return formData.onFailure(
            result.error.__typename,
            result.error.__typename === 'StartDeliveryInvalidInvoiceError' ? result.error.message : null
          );
        }
      } catch (error) {
        openToast('잠시 문제가 발생했어요.');
      }
    };

    openModal({
      content: (
        <StartDeliveryModal
          storeOrderId={storeOrderId}
          onClose={handleClose}
          onSubmit={handleSubmit}
        />
      ),
      isShow: true,
      disableBackdropClick: true,
    });
  }, []);

  return { openStartDeliveryModal };
};
